"use client";

import _objectSpread from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className", "bsPrefix", "as"];
import * as React from 'react';
import classNames from 'classnames';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const PopoverHeader = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      bsPrefix,
      as: Component = 'div'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'popover-header');
  return /*#__PURE__*/_jsx(Component, _objectSpread({
    ref: ref,
    className: classNames(className, bsPrefix)
  }, props));
});
PopoverHeader.displayName = 'PopoverHeader';
export default PopoverHeader;